import { useRole } from '../../../../common/hooks/useRole';
import { Box } from '../../../../common/ui/Box';
import { OfferModel } from '../../../model/OfferModel';

import { AgentParty } from './InvolvedParties/AgentParty';
import { CustomerParty } from './InvolvedParties/CustomerParty';
import { InvolvedPartyLayoutContext } from './InvolvedParties/InvolvedParty';
import { SupplierParty } from './InvolvedParties/SupplierParty';
import { VesselParty } from './InvolvedParties/VesselParty';

interface InvolvedPartiesProps {
    offer: OfferModel;
    layout?: 'horizontal' | 'vertical';
}

export const InvolvedParties = ({ offer, layout = 'horizontal' }: InvolvedPartiesProps) => {
    const role = useRole();

    return (
        <InvolvedPartyLayoutContext.Provider value={layout}>
            <Box
                display={layout === 'vertical' ? 'grid' : 'flex'}
                gridTemplateColumns={layout === 'vertical' ? 'min-content minmax(0, 1fr)' : undefined}
                columnGap={layout === 'vertical' ? 24 : 0}
                rowGap={layout === 'vertical' ? 16 : 0}
                alignContent={layout === 'vertical' ? 'start' : undefined}
                alignItems={layout === 'vertical' ? 'start' : undefined}
                width={layout === 'horizontal' ? '100%' : undefined}
            >
                <VesselParty vessel={offer.vessel} />

                {role.isCustomer() || role.isSuperAdmin() ? <SupplierParty supplier={offer.supplier} /> : null}
                {role.isSupplier() || role.isSuperAdmin() ? (
                    <CustomerParty customer={offer.customer} isSpot={offer.isSpot()} isEnquiry={offer.isEnquiry()} />
                ) : null}

                <AgentParty agent={offer.agentInformation} />
            </Box>
        </InvolvedPartyLayoutContext.Provider>
    );
};
